import { gql } from "@grandvisionhq/graphql";
import { cartDetails } from "../../../fragments/operations/fragments/cart-details.js";
import { cartValidationErrors } from "../../../fragments/operations/fragments/cart-validation-errors.js";
const REMOVE_CART_VOUCHER_CODES = gql`
  mutation RemoveCartVoucherCodes($cartInput: CartVoucherCodesInput!) {
    removeCartVoucherCodes(cartInput: $cartInput) {
      cart {
        ...CartDetailsFragment
      }
      validationErrors {
        ...CartValidationErrorsFragment
      }
      failures {
        ... on VoucherCodeNotApplicableFailure {
          cartId
          message
          code
          reason
          voucherCode
        }
        ... on UnknownCartMutationFailure {
          message
          code
        }
      }
      success
    }
  }
  ${cartDetails}
  ${cartValidationErrors}
`;
export {
  REMOVE_CART_VOUCHER_CODES
};
//# sourceMappingURL=remove-cart-voucher-codes.js.map
